import React from 'react';
import debounce from 'lodash/debounce';
import { MD_BREAKPOINT } from 'components/constants';

export default function MobileTextToggle({ mobileText, text }: Props) {
  const [onMobile, setOnMobile] = React.useState(window.document.body.clientWidth <= MD_BREAKPOINT);
  React.useEffect(() => {
    const listener = debounce(() => {
      setOnMobile(window.document.body.clientWidth <= MD_BREAKPOINT);
    }, 500);

    window.document.body.addEventListener('resize', listener);

    return () => {
      window.document.body.removeEventListener('resize', listener);
    };
  }, []);
  if (onMobile && mobileText) {
    return <>{mobileText}</>;
  }

  if (!onMobile && text) {
    return <>{text}</>;
  }

  return null;
}

interface Props {
  mobileText: React.ReactNode;
  text: React.ReactNode;
}
